/* eslint-disable */
import ShopSettingsAPI from "./data";

const state = {
  loading: false,
  settings: {},
  today: {},
  error: ""
};

// getters
const getters = {
};

// actions
const actions = {
  initShopSettings: context => {
    context.commit("SET_LOADING", true);
    return ShopSettingsAPI.list(context)
      .then(data => {
        context.commit("SET_SHOP_SETTINGS", data);
      })
      .catch(error => {
        context.commit("SET_ERROR", error);
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  updateShopSettings: (context, shopSettings) => {
    context.commit("SET_LOADING", true);
    return ShopSettingsAPI.update(context, shopSettings)
      .then(data => {
        context.commit("SET_SHOP_SETTINGS", data.results);
      })
      .catch(error => {
        context.commit("SET_ERROR", error);
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  },
  getTodayStats: (context) => {
    context.commit("SET_LOADING", true);
    return ShopSettingsAPI.stats.getTodayStats(context)
      .then(data => {
        context.commit("SET_TODAY_STATS", data);
      })
      .catch(error => {
        context.commit("SET_ERROR", error);
      })
      .finally(() => {
        context.commit("SET_LOADING", false);
      });
  }
};

// mutations
const mutations = {
  SET_SHOP_SETTINGS(state, settings) {
    state.settings = settings;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_TODAY_STATS(state, data) {
    state.today = data;
  }
};

export default { namespaced: true, state, getters, actions, mutations };
